import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-card-sort',
  	templateUrl: './toolcards-card-sort.component.html',
  	styleUrls: ['./toolcards-card-sort.component.scss']
})
export class ToolcardsCardSortComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
		this.env=environment;  		  		
  	}

}
